import { render, staticRenderFns } from "./QuickApply.vue?vue&type=template&id=b5a2ad88&scoped=true"
import script from "./QuickApply.vue?vue&type=script&lang=js"
export * from "./QuickApply.vue?vue&type=script&lang=js"
import style0 from "./QuickApply.vue?vue&type=style&index=0&id=b5a2ad88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a2ad88",
  null
  
)

export default component.exports